/* eslint-disable import/prefer-default-export */
export const isReferral = (type) => type === "referral";
export const isSellerLandlordType = (type) => type === "seller" || type === "landlord";

const BUYER_TENANT = ["buyer", "tenant"];
export const isBuyerTenant = (clientIntent) => BUYER_TENANT.includes(clientIntent);

export const isAgent = (userType) => userType === "Agent";
